import { TranslateService } from '@ngx-translate/core';

import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable, ErrorHandler, type Provider } from '@angular/core';

import { ToastService } from '@shared/ui/toast';

@Injectable()
class AppErrorHandler implements ErrorHandler {
  private readonly toast = inject(ToastService);
  private readonly translate = inject(TranslateService);

  handleError(error: unknown): void {
    if (error instanceof HttpErrorResponse) {
      return;
    }

    console.error('[AppErrorHandler]', error);

    queueMicrotask(() => {
      this.toast.error({
        summary: this.translate.instant('common.errors.unexpectedError'),
      });
    });
  }
}

export function provideAppErrorHandler(): Provider {
  return {
    provide: ErrorHandler,
    useClass: AppErrorHandler,
  };
}
